import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import AuthorizeUserTree from './authorizeUserTree.component';
import { routesPermissions } from '../../routesPermissions';

class AuthorizedRoute extends PureComponent {
  static propTypes = {
    path: PropTypes.string.isRequired,
    component: PropTypes.elementType,
    render: PropTypes.func,
    exact: PropTypes.bool,
  };

  static defaultProps = {
    withPermissions: [],
    withAssignments: [],
    exact: false,
  };

  render() {
    const {
      path,
      component,
      render,
      exact,
    } = this.props;

    const {
      withPermissions,
      withAssignments,
    } = routesPermissions[path] ?? {};

    return (
      <AuthorizeUserTree
        withPermissions={withPermissions}
        withAssignments={withAssignments}
      >
        <Route
          exact={exact}
          path={path}
          component={component}
          render={render}
        />
      </AuthorizeUserTree>
    );
  }
}

export default withRouter(AuthorizedRoute);
